function f() {
  function e(o, r = window.omikuji.shopSettings.money_with_currency_format) {
    const s = /\{\{\s*(\w+)\s*\}\}/;
    let t = "";
    function n(i, a, u, c) {
      if (a = a ?? 2, u = u ?? ",", c = c ?? ".", isNaN(i) || i == null)
        return "0";
      const m = (i / 100).toFixed(a).split("."), d = m[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + u), _ = m[1] ? c + m[1] : "";
      return d + _;
    }
    switch (r.match(s)[1]) {
      case "amount":
        t = n(o, 2);
        break;
      case "amount_no_decimals":
        t = n(o, 0);
        break;
      case "amount_with_comma_separator":
        t = n(o, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        t = n(o, 0, ".", ",");
        break;
    }
    return r.replace(s, t);
  }
  return { formatMoney: e };
}
var l = /* @__PURE__ */ ((e) => (e.ADDTOCART = "omikuji-add-to-cart", e.OPENCART = "omikuji-open-cart", e))(l || {});
function v() {
  window.omikuji.__eventBus || (window.omikuji.__eventBus = new Comment("omikuji-event-bus"));
  const e = window.omikuji.__eventBus;
  function o(t, n) {
    const i = n ? new CustomEvent(t, { detail: n }) : new CustomEvent(t);
    e.dispatchEvent(i);
  }
  function r(t) {
    return "detail" in t;
  }
  async function s(t, n) {
    const i = async (a) => {
      if (r(a)) {
        const u = a.detail;
        await n(u);
      }
    };
    return e.addEventListener(t, i), () => {
      e.removeEventListener(t, i);
    };
  }
  return { subscribe: s, publish: o };
}
export {
  l as O,
  v as a,
  f as u
};
